import {useState, useEffect} from "react"
import {Player} from "./Player"

export const SuggestedTrades = ({difference, closest, summedTot}) => {
    const [five, setFive] = useState(0)

    useEffect(() => {
        setFive(.05 * summedTot)
    }, [summedTot])
    return (
    <div className="is-flex is-justify-content-center">
        <div style={{border: "1px solid black"}}>
            <div style={{padding: "1rem", backgroundColor: "#22356E", fontWeight: 'bold', color: "white"}}>
            This trade favors {difference > 0 ? "Team 1" : "Team 2"} by {Math.round(Math.abs(difference) * 10)/10} total points.
            </div>
            <div style={{padding: "1rem"}}>
            {five > Math.abs(difference) && (
                <div>This value falls within a 5% confidence range, so we call it pretty even. Trade away!</div>
                )}
            {five < Math.abs(difference) && (
                <div>
                    This value is significantly different. Here are some suggested players to even the trade up!
                    {closest.map((player, i) => {
                        return (
                            <Player key={`suggested-player-${i}`} player={player} handleClick={false}/>
                        )
                    })}
                </div>    
            )}
            </div>
            
        </div>
    </div>
    )
}